import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

const apiUrl = environment.API_URI;

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  constructor(private http: HttpClient) { }

  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem("user_token");
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
  }

  getDocuments() {
    return this.http.get(`${apiUrl}/document`);
  }

  getRequiredDocumentsByUser(userId: any) {
    return this.http.get(`${apiUrl}/api/required_documents/${userId}`, { headers: this.getHeaders() });
  }

  getUploadedDocumentsByUser(userId: any) {
    return this.http.get(`${apiUrl}/api/documents_media/${userId}`, { headers: this.getHeaders() });
  }

  getPublicDocumentsByUser(userId: any) {
    return this.http.get(`${apiUrl}/api/public_documents/${userId}`, { headers: this.getHeaders() });
  }

  getOneDocument(id) {
    return this.http.get(`${apiUrl}/document/${id}`);
  }

  addDocument(data) {
    return this.http.post(`${apiUrl}/document`, data);
  }

  editDocument(id, data) {
    return this.http.put(`${apiUrl}/document/${id}`, data);
  }

  deleteDocument(id) {
    return this.http.delete(`${apiUrl}/document/${id}`);
  }
}
